import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './session-transcripts.types';
import * as constants from './session-transcripts.constants';

export const storeSessionTranscript = generateStoreResourceAction<types.ISessionTranscript>(
  constants.STORE_SESSION_TRANSCRIPT,
);
export const clearSessionTranscript = generateClearResourceAction(constants.CLEAR_SESSION_TRANSCRIPT);
